// keep in sync with backend
export const NEW_USER_BIT_BONUS = 20;
